/**
 * <s-variant-select> — keeps a hidden input[name="id"] in sync with a plain variant <select>,
 * so a compact upsell form still submits through <s-product-form>.
 *
 * Required markup:
 *   select[data-variant-select]       — options carry variant IDs as values
 *   input[type="hidden"][name="id"]   — submitted variant ID
 */
class SVariantSelect extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-variant-select]')) return;
      const input = this.querySelector('input[name="id"]');
      if (input instanceof HTMLInputElement) input.value = event.target.value;
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-variant-select')) {
  customElements.define('s-variant-select', SVariantSelect);
}
